/*
 * @Author: Wang Wenmao
 * @Date: 2023-09-26 11:06:59
 * @LastEditors: Wang Wenmao
 * @LastEditTime: 2023-12-11 19:33:28
 * @Description: 商品参数展示配置-编辑参数
 */

import React from 'react';
import { Row, Col, Button, Table, Icon, Input, Popconfirm, Modal, message } from 'antd';
import { DndProvider, DragSource, DropTarget } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import update from 'immutability-helper';
import qs from 'qs';
import Dialog from './dialog';
import { services } from '@comall-backend-builder/core';
import { errorHandle } from '../../services';

import './index.less';

const { confirm } = Modal;

const { api } = services;

let dragingIndex = -1;

const getHashPathParameter = () => {
    const hash = window.location.hash;
    const segments = hash.split('/');
    const param = segments[3];
    return param;
};

export class DisplayLocationInfo extends React.Component {
    columns: any = [
        {
            title: '属性编码',
            dataIndex: 'code',
            key: 'code',
            align: 'center',
        },
        {
            title: '属性名称',
            dataIndex: 'name',
            key: 'name',
            align: 'center',
        },
        {
            title: '字典编码',
            dataIndex: 'sapCode',
            key: 'sapCode',
            align: 'center',
        },
        {
            title: '属性类型',
            dataIndex: 'type',
            key: 'type',
            align: 'center',
        },
        {
            title: '品真阁显示名称',
            dataIndex: 'showName',
            key: 'showName',
            align: 'center',
            render: (name: string, item: any, index: number) => {
                const { edit } = item;
                const { pageSize } = this.state;
                const i = (this.state.currentPage - 1) * pageSize + index;
                return edit ? (
                    <Input
                        style={{ width: '150px' }}
                        defaultValue={name}
                        placeholder="请输入"
                        onChange={({ target }) => this.handleChangeName(target.value, i)}
                    />
                ) : (
                    <span>{name}</span>
                );
            },
        },
        {
            title: '拖动调整顺序',
            dataIndex: 'order',
            key: 'order',
            align: 'center',
            render: () => (
                <span className="drag" onMouseDown={this.onMouseDown}>
                    <Icon type="drag" />
                </span>
            ),
        },
        {
            title: '操作',
            dataIndex: 'x',
            key: 'x',
            align: 'center',
            render: (_: any, item: any, index: number) => {
                const { pageSize } = this.state;
                const i = (this.state.currentPage - 1) * pageSize + index;
                return (
                    <div>
                        {!item.edit ? (
                            <Button
                                type="link"
                                onClick={() => this.handleClickRowOps('edit', item, i)}
                            >
                                编辑显示名称
                            </Button>
                        ) : (
                            <>
                                <Button
                                    type="link"
                                    onClick={() => this.handleClickRowOps('save', item, i)}
                                >
                                    保存
                                </Button>
                                <Button
                                    type="link"
                                    onClick={() => this.handleClickRowOps('cancel', item, i)}
                                >
                                    取消
                                </Button>
                            </>
                        )}

                        <Popconfirm
                            placement="top"
                            title="您确定要删除吗？"
                            onConfirm={() => this.handleClickRowOps('delete', item, i)}
                            okText="确定"
                            cancelText="取消"
                        >
                            <Button type="link">删除</Button>
                        </Popconfirm>
                    </div>
                );
            },
        },
    ];

    state = {
        dataSources: [],
        isDrag: false,
        selectedRowKeys: [],
        visible: false,
        loading: false,
        currentPage: 1,
        pageSize: 10,
    };

    rowSource = {
        beginDrag(props: { index: number }) {
            dragingIndex = props.index;
            return { index: props.index };
        },
    };

    rowTarget = {
        drop(
            props: { index: any; moveRow: (arg0: any, arg1: any) => void },
            monitor: { getItem: () => { (): any; new (): any; index: any } }
        ) {
            const dragIndex = monitor.getItem().index;
            const hoverIndex = props.index;

            // Don't replace items with themselves
            if (dragIndex === hoverIndex) {
                return;
            }

            // Time to actually perform the action
            props.moveRow(dragIndex, hoverIndex);

            // Note: we're mutating the monitor item here!
            // Generally it's better to avoid mutations,
            // but it's good here for the sake of performance
            // to avoid expensive index searches.
            monitor.getItem().index = hoverIndex;
        },
    };

    componentDidMount(): void {
        this.getZHPPLAttrList();
    }

    // 获取表格列表
    getZHPPLAttrList = () => {
        const option_code = getHashPathParameter();
        if (!option_code) return;
        this.setState({ loading: true });
        const apiPath = `/products/getZHPPLAttrList?option_code=${option_code}`;
        api.get({}, { apiPath })
            .then((res: any) => this.setState({ dataSources: res }))
            .catch(errorHandle)
            .finally(() => this.setState({ loading: false }));
    };

    // 重写BodyRow
    BodyRow = (props: {
        [x: string]: any;
        isOver: any;
        connectDragSource: any;
        connectDropTarget: any;
        moveRow: any;
    }) => {
        const { isOver, connectDragSource, connectDropTarget, moveRow, ...restProps } = props;
        const { isDrag } = this.state;
        const style = { ...restProps.style, cursor: 'move' };

        let { className } = restProps;
        if (isOver) {
            if (restProps.index > dragingIndex) {
                className += ' drop-over-downward';
            }
            if (restProps.index < dragingIndex) {
                className += ' drop-over-upward';
            }
        }

        if (isDrag) {
            return connectDragSource(
                connectDropTarget(<tr {...restProps} className={className} style={style} />)
            );
        } else {
            return <tr {...restProps} />;
        }
    };

    // 重写BodyRow
    DragableBodyRow = DropTarget('row', this.rowTarget, (connect, monitor) => ({
        connectDropTarget: connect.dropTarget(),
        isOver: monitor.isOver(),
    }))(
        DragSource('row', this.rowSource, (connect) => ({
            connectDragSource: connect.dragSource(),
        }))(this.BodyRow)
    );

    // 重写components
    components = { body: { row: this.DragableBodyRow } };

    // 按下开启拖拽
    onMouseDown = () => this.setState({ isDrag: true });

    // 去重
    uniqueArray = (arr: any[]) => {
        return arr.reduce((acc: any[], current: { id: any }) => {
            if (!acc.some((item) => item.id === current.id)) {
                acc.push(current);
            }
            return acc;
        }, []);
    };

    // 拖拽排序
    moveRow = (dragIndex: number, hoverIndex: number) => {
        const { dataSources, isDrag, currentPage, pageSize } = this.state;
        if (!isDrag) return;

        // 调整索引基于整个数据集而非当前页
        const adjustedDragIndex = (currentPage - 1) * pageSize + dragIndex;
        const adjustedHoverIndex = (currentPage - 1) * pageSize + hoverIndex;

        // 检查索引是否有效
        if (
            adjustedDragIndex < 0 ||
            adjustedHoverIndex < 0 ||
            adjustedDragIndex >= dataSources.length ||
            adjustedHoverIndex >= dataSources.length
        ) {
            return;
        }

        const dragRow = dataSources[adjustedDragIndex];

        // 使用 immutability-helper 更新 dataSources
        const newDataSource = update(dataSources, {
            $splice: [
                [adjustedDragIndex, 1],
                [adjustedHoverIndex, 0, dragRow],
            ],
        });
        const uniqueDataSource = this.uniqueArray(newDataSource);
        // 使用更新后的数据源更新状态
        this.setState({ dataSources: uniqueDataSource }, () => {
            //state 已经更新，可以关闭拖拽标志
            this.setState({ isDrag: false });
            this.saveNewOrderToServer(uniqueDataSource);
        });
    };

    // 模拟保存新顺序到服务器的函数
    saveNewOrderToServer = (AttributeVo: any[]) => {
        // 发送请求到服务器保存新的顺序
        const apiPath = `/products/updateAttrOptionOrder/${getHashPathParameter()}`;
        api.post({ AttributeVo }, { apiPath })
            .then(() => {
                message.success('调整成功');
                this.getZHPPLAttrList();
            })
            .catch(errorHandle);
    };

    // 删除属性
    handleDeleteAttr = (ids: number[]) => {
        const idStr = ids.map((el) => 'ids=' + el).join('&');
        const apiPath = `/products/deleteAttr?${idStr}`;

        api.delete({}, { apiPath })
            .then(() => {
                message.success('删除成功');
                this.getZHPPLAttrList();
            })
            .catch(errorHandle);
    };

    // 保存新名称
    updateAttrShowName = (item: any) => {
        const params = qs.stringify({
            id: item.id,
            attr_show_name: item.showName,
        });
        const apiPath = `/products/updateAttrShowName?${params}`;

        api.put({}, { apiPath })
            .then(() => message.success('修改成功'))
            .catch(errorHandle);
    };

    // 保存新顺序
    updateAttrOptionOrder = () => {
        const apiPath = `/products/updateAttrOptionOrder`;
    };

    /**
     * 点击操作按钮
     * @param type  edit | save | cancel | delete
     * @param item 当前行的数据
     * @param index  当前行的索引
     */
    handleClickRowOps = (type: string, item: any, index: number) => {
        const { dataSources } = this.state;
        const newDataSources = [...dataSources] as any;
        const current = newDataSources[index];

        if (type === 'edit') {
            current.edit = true;
        }

        if (type === 'save') {
            if (current.showNameCopy) {
                current.showName = current.showNameCopy;
                this.updateAttrShowName(current);
            }
            current.edit = false;
        }

        if (type === 'cancel') {
            current.showNameCopy = '';
            current.edit = false;
        }

        if (type === 'delete') {
            this.handleDeleteAttr([item.id]);
        }
        this.setState({ dataSources: newDataSources });
    };

    // 修改显示名称
    handleChangeName = (value: string, index: number) => {
        const { dataSources } = this.state;
        const newDataSources = [...dataSources] as any;
        newDataSources[index].showNameCopy = value;
        this.setState({ dataSources: newDataSources });
    };

    // 批量选择
    handleChangeRowSelection = (selectedRowKeys: string[]) => this.setState({ selectedRowKeys });

    /**
     * 添加参数 & 批量删除
     * @param type add | delete
     */
    handleClickTableOps = (type: string) => {
        if (type === 'add') {
            this.setState({ visible: true });
        }

        if (type === 'delete') {
            const { selectedRowKeys } = this.state;
            if (selectedRowKeys.length === 0) {
                message.warning('请至少选择一项');
                return;
            }

            confirm({
                title: '确定删除吗?',
                content: '删除后不可恢复',
                okText: '确定',
                okType: 'primary',
                cancelText: '取消',
                onOk: () => this.handleDeleteAttr(selectedRowKeys),
            });
        }
    };

    // 关闭弹窗
    handleCloseModal = (flag: boolean) => {
        if (flag) this.getZHPPLAttrList();
        this.setState({ visible: false });
    };

    render() {
        const { dataSources, visible, loading, currentPage, pageSize } = this.state;

        const props: any = {
            rowKey: 'id',
            loading,
            style: { marginTop: 20 },
            columns: this.columns,
            dataSource: dataSources,
            components: this.components,
            onRow: (_: any, index: number) => ({ index, moveRow: this.moveRow }),
            rowSelection: { onChange: this.handleChangeRowSelection },
            pagination: {
                current: currentPage,
                pageSize,
                total: dataSources.length,
                showTotal: (total: number) => `共 ${total} 条`,
                showSizeChanger: true,
                pageSizeOptions: ['10', '20', '30', '40', '50'],
                onChange: (current: number) => this.setState({ currentPage: current }),
                onShowSizeChange: (_: number, pageSize: any) =>
                    this.setState({ currentPage: 1, pageSize }),
            },
        };

        return (
            <div className="display-location-info">
                <Row type="flex" justify="space-between">
                    <Col>
                        <Button type="primary" onClick={() => this.handleClickTableOps('add')}>
                            添加参数
                        </Button>
                        <Button
                            style={{ marginLeft: 10 }}
                            onClick={() => this.handleClickTableOps('delete')}
                        >
                            批量删除
                        </Button>
                    </Col>
                    <Col>
                        <Button onClick={() => window.history.back()}>返回</Button>
                    </Col>
                </Row>

                <DndProvider backend={HTML5Backend}>
                    <Table {...props} />
                </DndProvider>

                <Dialog
                    visible={visible}
                    selectedCodes={dataSources.map((el) => el.code)}
                    onClose={this.handleCloseModal}
                />
            </div>
        );
    }
}
